import BaseAPIClient from './base/BaseAPIClient';

export default class WorkshopClient extends BaseAPIClient {
  refund(workshopId, studentUserId) {
    return this._post(
      `v2/workshops/refund/`,
      { workshopId, studentUserId }
    );
  }
  register(userId, workshopId, tryPayWithCredit) {
    return this._post(
      `v2/workshops/register/`,
      { userId, workshopId, tryPayWithCredit }
    );
  }
  deregister(workshopId, studentUserId) {
    return this._post(
      `v2/workshops/deregister/`,
      { workshopId, studentUserId }
    );
  }
  cancel(workshopId){
    return this._post(
      `v2/workshops/cancel/`,
      { workshopId }
    );
  }
  listForAdmin(pageToken, counselorId, startsAfter, startsBefore, specialtyIds, excludedStatuses) {
    return this._get(
      'v2/workshops/bettermynd-admin/list/',
      { pageToken, counselorId, startsAfter, startsBefore, specialtyIds, excludedStatuses }
    );
  }
  listForUser(pageToken, userId, startsAfter, startsBefore, specialtyIds, userIsAttending) {
    return this._get(
      'v2/workshops/user/list/',
      { pageToken, userId, startsAfter, startsBefore, specialtyIds, userIsAttending }
    );
  }
  listForCounselor(pageToken, counselorId, startsAfter, startsBefore, specialtyIds, excludedStatuses) {
    return this._get(
      'v2/workshops/counselor/list/',
      { pageToken, counselorId, startsAfter, startsBefore, specialtyIds, excludedStatuses }
    );
  }
  withdrawByUser(workshopId, studentUserId) {
    return this._post(
      `v2/workshops/withdraw/`,
      { workshopId, studentUserId }
    );
  }
  rejectWorkshopRequest(workshopId){
    return this._post(
      `v2/workshops/reject/`, { workshopId }
    );
  }
  approveWorkshopRequest(workshopId){
    return this._post(
      `v2/workshops/approve/`, { workshopId }
    );
  }
}